// Interfaces
import FormData from "Interfaces/FormDataInterface";
import ContractType from "Interfaces/AdvanceSearchInterface";

function getUniqueContractSegments(query: FormData){
  const segments : string[] = [];
  if (query.contractTypes){
    query.contractTypes.map(conType => {
        conType.contracts.map(con => {
            if (query.contracts.indexOf(con.id) >= 0) {
                con.contractSegments.map(seg => {
                    if (segments.indexOf(seg) === -1) {
                        segments.push(seg)
                    }
                })
            }
        })
    });
  }
  return segments;        
}

export {
  getUniqueContractSegments,
};
